import { Label, RadialBar, RadialBarChart, PolarGrid, PolarRadiusAxis, PolarAngleAxis } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter,
} from "../ui/card";
import {
  ChartContainer,
} from "../ui/chart";

export const description = "Temperature Value";

export default function TemperatureVictron(props) {

  const maxValue = 100;
  
    const getColor = (value) => {
      if (value >= 0 && value <= 40) {
        return "#3CB371"; // Green 
      } else if (value > 40 && value <= 60) {
        return "#FFA500"; // Orange
      } else if (value > 60) {
        return "#FF4500"; // Red
      } else {
        return "#D3D3D3"; // Grey as default
      }
    };
  
    const chartData = [
      {
        temperature: props.temperature,
        value: parseFloat(props.temperature?.match(/\d+(\.\d+)?/)?.[0] || "0"),
        fill: getColor(parseFloat(props.temperature?.match(/\d+(\.\d+)?/)?.[0] || "0")),
      },
    ];
  
    return (
      <Card className="flex flex-col min-h-[300px] min-w-[250px]">
        <CardHeader className="flex flex-col items-center pb-0 text-center">
          <CardTitle>Temperature</CardTitle>
          <CardDescription>Live</CardDescription>
        </CardHeader>
        <CardContent className="flex-1 pb-0">
          <ChartContainer
            config={chartData}
            className="mx-auto aspect-square max-h-[250px] min-h-[200px]"
          >
            <RadialBarChart
              data={chartData}
              startAngle={0}
              endAngle={360}
              innerRadius={80}
              outerRadius={110}
            >
              <PolarGrid
                gridType="circle"
                radialLines={false}
                stroke="none"
                className="first:fill-muted last:fill-background"
                polarRadius={[86, 74]}
              />
              <RadialBar dataKey="value" background cornerRadius={10} />
              <PolarRadiusAxis tick={false} tickLine={false} axisLine={false}>
                <Label
                  content={({ viewBox }) => {
                    if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                      return (
                        <text
                          x={viewBox.cx}
                          y={viewBox.cy}
                          textAnchor="middle"
                          dominantBaseline="middle"
                        >
                          <tspan
                            x={viewBox.cx}
                            y={viewBox.cy}
                            className="fill-foreground text-3xl font-bold"
                          >
                            {props.temperature}
                          </tspan>
                        </text>
                      );
                    }
                  }}
                />
              </PolarRadiusAxis>
            </RadialBarChart>
          </ChartContainer>
        </CardContent>
        <CardFooter className="flex-col gap-2 text-sm">
        </CardFooter>
      </Card>
    );
};